module.exports = __webpack_public_path__ + "static/2-80f0f183a3a8511b7f6c382df694d6aa.png";